import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-b5458be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-nav flex items-center justify-between flex-wrap bg-primary-fill" }
const _hoisted_2 = { class: "container m-auto" }
const _hoisted_3 = { class: "flex items-center flex-shrink-0 text-white container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Parcel 4 you"
}, null, -1))
const _hoisted_5 = { class: "ml-12 flex relative w-11/12" }
const _hoisted_6 = { class: "w-1/6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main-nav__item__icon icon-proposals" }, null, -1))
const _hoisted_8 = { class: "w-1/6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main-nav__item__icon icon-clients" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4/12" }, null, -1))
const _hoisted_11 = { class: "main-nav__item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main-nav__item__icon icon-clients" }, null, -1))
const _hoisted_13 = { class: "main-nav__item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main-nav__item__icon icon-clients" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "w-1/12",
          to: {name: 'dashboard'}
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "main-nav__item",
              "active-class": "main-nav__item--active",
              to: {name: 'proposal.list'}
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('general.nav.proposals')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "main-nav__item",
              "active-class": "main-nav__item--active",
              to: {name: 'customers.list'}
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('general.nav.clients')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_10,
          (_ctx.userAdmin)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "w-1/6 cursor-pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAdminPanelClick && _ctx.handleAdminPanelClick(...args)))
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("general.nav.admin_panel")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            class: "w-1/6 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('logoutClick')))
          }, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.nav.log_out")), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}